<div class="about-container"
  [ngStyle]="{ padding: linePadding }"
>
  <div>
    <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
    </vsf-title-box>
  </div>
  <!-- About Text Content Section -->
  <div *ngIf="text" class="about-text px-4">
    <div class="rich-text-content" [innerHtml]="text | safeHtml"></div>
  </div>

  <div class="flex flex-col md:flex-row flex-wrap items-center">
    <!-- Featured Image Section -->
    <div
      *ngIf="featuredAsset"
      class="about-featured-image overflow-hidden order-1 md:order-2 w-full md:w-1/2 md:p-2"
    >
      <img
        [src]="featuredAsset | assetPreview:'full':'webp'"
        [alt]="featuredAsset.customFields?.altText ? featuredAsset.customFields?.altText: 'Featured Image'"
        class="overflow-hidden w-full h-full object-contain"
      />
    </div>

    <!-- Citation Section -->
    <div
      *ngIf="citation"
      class="flex flex-col mt-2 order-2 md:order-1 w-full md:w-1/2 px-4 md:p-2"
    >
      <div class="quote-left-container">
        <div class="citation-text">
          <span class="rich-text-content" [innerHtml]="citation | safeHtml"></span>
        </div>
    </div>
  </div>
</div>